export default {
  ecc: {
    title: '云服务器',
    pageHeader: '云服务器',
    // 实例
    instance: {
      name: '实例',
      purchaseBtn: '购买云服务器',
      // 搜索栏
      searchBar: {
        formPlaceholder: '搜索ID / IP / 名称',
        searchBtn: '搜索'
      },
      // 地区筛选
      locationFilter: {
        header: '地域',
        placeholder: '选择一个地域进行筛选'
      },
      // 实例列表
      dataList: {
        emptyTips: {
          noInstance: '没有实例',
          guid: '在我们全球任意位置的数据中心部署新服务器。',
          recharge: '充值余额',
        },
        purchaseGuide: {
          tip: '没有数据，您可以',
          purchaseLink: '创建一个实例'
        },
        columns: {
          name: '实例名 / IP地址',
          publicIp: '公网IP',
          internalIp: '内网IP',
          intranet: '内网网段',
          subnetMask: '子网掩码',
          gateway: '网关',
          config: '配置',
          os: '操作系统',
          securityGroup: '安全组',
          zone: '所在地域',
          createTime: '创建时间',
          expireTime: '到期时间',
          status: {
            header: '状态',
            creating: '创建中',
            installing: '安装中',
            starting: '启动中',
            running: '运行中',
            stopping: '关机中',
            stopped: '已关机',
            expiresSoon: '将过期',
            unknown: '未知状态'
          },
          actions: '操作'
        },
        actions: {
          enabled: '已启用',
          disabled: '已禁用',
          connect: '登录服务器',
          renew: '续费',
          view: '查看',
          createSnapShot: '创建快照',
          addToIntranet: '加入内网',
          addReservedIp: '购买独立IP',
          status: '实例状态',
          start: '启动',
          stop: '停止',
          restart: '重启',
          upDowngrade: '升降级',
          upgrade: '升级',
          downgrade: '降级',
          reinstall: '重装',
          resetPassword: '重置密码',
          rename: '重命名',
          viewSnapshot: '查看快照',
          addToSecurityGroup: '添加到安全组'
        },
        massActions: '批量操作',
      },
      // 续费弹框
      renewDialog: {
        copySuccess:'复制成功',
        copyFail:'复制失败',
        header: '续费',
        instanceCounter: '已选 <span style="color:#37f;">#num#</span> 台实例',
        summary: {
          name: '概要',
          publicIp: '公网IP地址',
          io: '已 I/O 优化',
          statusRunning: '运行中',
          statusStopped: '已停止',
          temporaryBandwidth: '临时'
        },
        duration: {
          header: '时长',
          month: '月',
          months: '月',
          year: '年',
          years: '年',
        },
        password: {
          header: '密码',
          placeholder: '请输入登录密码'
        },
        charges: {
          name: '费用',
          headerProduct: '产品',
          headerCharge: '费用',
          productServer: '服务器',
          productDisk: '磁盘',
          productIp: 'IP'
        },
        buttons: {
          cancel: '取消',
          pay: '支付',
          pending: '处理中'
        }
      },
      // 添加到安全组弹框
      addToSecurityGroupDialog: {
        header: '添加到安全组',
        emptyGroupTips: {
          tip1: '无安全组，请',
          tip2: '创建一个'
        },
        groupSelector: {
          header: '已选择的安全组',
          placeholder: '请选择一个安全组'
        },
        instanceSelector: {
          header: '已选择的实例',
          instruction1: '所选安全组的规则将在所选实例上自动生效。',
          instruction2: '实例首次加入安全组时，默认拒绝所有端口。请根据需要添加入站规则。'
        },
        buttons: {
          cancel: '取消',
          add: '添加'
        }
      },
      // 创建快照弹框
      createSnapshotDialog: {
        header: '创建快照',
        instance: {header: '关联服务器'},
        disks: {
          header: '选择磁盘',
          search: '搜索'
        },
        tip: '为了确保快照创建成功，正在创建快照时，请勿修改实例状态，比如关机、重启实例或重装等任何操作，否则会创建失败。',
        buttons: {
          cancel: '取消',
          create: '创建'
        }
      },
      // 加入内网弹框
      addToIntranetDialog: {
        header: '加入内网',
        selectedInstance: {
          instance: '实例',
          ip: '公网IP'
        },
        intranetPicker: {
          header: '内网'
        },
        ipPicker: {
          header: '选择一个内网 IP'
        },
        noIntranetTips: {
          tip1: '无内网，请',
          tip2: '创建一个'
        },
        agreement: '勾选则不关机，需进入服务器配置内网；请先关机再加入内网',
        tip: '实例开机情况下，您也可以自行登录实例配置内网。',
        tip2: '请先关机以便我们为您配置内网。',
        buttons: {
          cancel: '取消',
          add: '加入'
        }
      },
      // 购买IP弹框
      buyIpDialog: {
        header: '购买IP',
        quantity: '数量',
        bandwidth: '带宽',
        duration: {
          header: '时长',
          month: '月',
          months: '月',
          year: '年',
          years: '年'
        },
        tips: {
          tip1: '本次升级有效期为 #expireDate#，下次计费周期续费所需费用为 #amount#；',
          tip2: '购买IP后，该服务器会自动重启完成绑定；',
          tip3: 'IP只能绑定同机房的云服务器；',
          tip4: '每台云服务器最多绑定10个IP；'
        },
        charges: {header: '费用'},
        buttons: {
          cancel: '取消',
          pay: '支付'
        }
      },
      // 关机弹框
      shutdownDialog: {
        header: '关机',
        selectedInstance: {
          countDesc: '您已选<span style="color:#37f;">#num#</span><span>台实例</span>',
          statusStoppable: '可关机',
          statusUnstoppable: '不可关机'
        },
        tips: {
          tip1: '您确定要对该云服务器执行关机操作？关机期间，主机将无法正常提供服务，请您做好准备，以免造成影响',
          tip2: '强制关机可能会导致数据丢失或文件系统损坏，请仅在服务器不能正常关机时使用。',
        },
        shutdownConfirmation: '确认使用强制关机。',
        buttons: {
          cancel: '取消',
          stop: '关机'
        }
      },
      // 开机弹框
      bootDialog: {
        header: '开机',
        selectedInstance: {
          countDesc: '您已选 <span style="color:#37f;">#num#</span> <span>台</span>实例',
          statusStartable: '可开机',
          statusUnstartable: '不可开机'
        },
        buttons: {
          cancel: '取消',
          start: '开机'
        }
      },
      // 重启弹框
      rebootDialog: {
        header: '重启',
        selectedInstance: {
          countDesc: '已选择 <span style="color:#37f;">#num#</span> <span>台</span>实例',
          statusRestartable: '可重启',
          statusNonrestartable: '不可重启'
        },
        tips: {
          tip1: '确定重启该云服务器？重启期间，主机将无法正常提供服务，请您做好准备，以免造成影响。',
          tip2: '强制关机可能会导致数据丢失或文件系统损坏，请仅在服务器不能正常关机时使用。'
        },
        restartConfirmation: '确认强制重启。',
        buttons: {
          cancel: '取消',
          restart: '重启'
        }
      },
      // 升降级弹框
      upDowngradeDialog: {
        header: {
          up: '升级',
          down: '降级'
        },
        headerMemory: '内存',
        headerBandwidth: '带宽',
        headerConfig: '配置列表',
        configColumns: {
          items: '升级项目',
          current: '当前配置',
          upgradeTo: '升级至',
          downgradeTo: '降级到',
          charges: '费用',
          expireTime: '到期时间'
        },
        configRows: {
          bandwidth: '带宽',
          memory: '内存',
        },
        tips: {
          tip1: '本次升级有效期至 #ended# 之后，下次计费周期续费所需费用为$ #monthAmount#。',
          tip2: '#operation#CPU、内存需要重启实例才能生效。',
          tip3: '带宽#operation#实时生效'
        },
        operations: {
          upgrade: '升级',
          downgrade: '降级'
        },
        fee: {
          price: '费用',
          reduce: '减少'
        },
        buttons: {
          cancel: '取消',
          done: '确定'
        }
      },
      // 重装系统弹框
      reinstallDialog: {
        header: '重装系统',
        mirror: {
          header: '选择镜像',
          os: '操作系统'
        },
        account: {
          header: '账号',
          user: {
            header: '用户'
          },
          password: {
            header: '密码',
            tip: '8~16个字符，同时包含大小写字母和数字以及特殊符号[!?@#^&*()_+\\-=.]。'
          }
        },
        tips: {
          tip1: '重装后，服务器系统盘内的所有数据将被清除，恢复到初始状态。',
          tip2: '单独购买的数据盘需要手动挂载才能使用。',
          tip3: '重装系统会把系统盘的快照删除，无法恢复，请谨慎操作。'
        },
        buttons: {
          cancel: '取消',
          reinstall: '重装'
        }
      },
      // 重置密码弹框
      resetPwdDialog: {
        header: '重置密码',
        n: {
          header: '新密码',
          placeholder: '请输入新密码',
          tip: '8~16 个字符。至少包含 3 种大小写字母、数字和特殊字符（!@#^&*()_+-=）。'
        },
        c: {
          header: '确认新密码',
          placeholder: '请再次输入新密码'
        },
        tip: '注意：修改密码后服务器会重启，可能导致数据丢失或文件系统损坏。',
        buttons: {
          cancel: '取消',
          done: '确定'
        }
      },
      // 重命名弹框
      renameDialog: {
        header: '修改名称',
        newName: {
          header: '新名称',
          placeholder: '请输入新实例名称'
        },
        description: {
          header: '描述'
        },
        buttons: {
          cancel: '取消',
          rename: '重命名'
        }
      },
      // 页面
      pages: {
        // 详情页
        detail: {
          tabs: {
            detail: '详情',
            monitoring: '监控',
            operationLog: '操作日志'
          },
          tabDetail: {
            bandwidthSpeed: '当前网速',
            cpuUsage: 'CPU使用率',
            currentCharges: '当前收费情况',
            durationUnit: '月',
            basicInfo: {
              header: '基本信息',
              name: '名称',
              status: '状态',
              description: '描述',
              type: '业务类型',
              zone: '所在地域',
              account: '用户账号'
            },
            configInfo: {
              header: '配置信息',
              memory: '内存',
              hardDisk: '硬盘',
              os: '操纵系统',
              publicIp: '公网IP',
              internalIp: '内网IP',
              bandwidth: '带宽'
            },
            otherInfo: {
              header: '其他信息',
              createdAt: '创建时间',
              expiresAt: '到期时间'
            }
          },
          tabMonitoring: {
            cpu: 'CPU使用情况（%）',
            memory: '内存使用情况（%）',
            disk: '磁盘使用情况',
            diskCounters: {
              read: '读出量',
              write: '写入量',
              readRequests: '读次数',
              writeRequests: '写次数'
            },
            bandwidth: '带宽使用情况',
            networkEvents: {
              in: '接收',
              out: '发送',
              inPackets: '接收包',
              outPackets: '发送包'
            },
            granularity: {
              day: '天',
              hour: '小时',
              min: '分钟'
            },
          },
          tabOperationLog: {
            headerCols: {
              operation: '操作名称',
              operator: '用户名',
              ip: 'IP地址',
              time: '操作时间'
            }
          }
        },
        loginPage: {header: '登录服务器'}
      }
    },
    // 磁盘
    storage: {
      name: '云磁盘',
      // 购买磁盘弹框
      purchaseDialog: {
        header: '购买磁盘',
        region: {header: '地区/区域：', regionPlaceholder: '请选择地区', zonePlaceholder: '请选择区域'},
        instance: {header: '关联实例：', placeholder: '请选择要挂载的实例'},
        disk: {header: '磁盘类型：', placeholder: '请选择磁盘类型', types: {normal: '普通云盘', he: '高效云盘'}},
        quantity: {header: '数量：', unit: '块'},
        capacity: {header: '容量：'},
        duration: {header: '时长：', units: {month: '月', months: '月', year: '年', years: '年'}},
        charges: '费用：',
        buttons: {cancel: '取消', buy: '立即购买', pending: '处理中'}
      },
      // 购买触发按钮
      purchaseTrigger: '购买云磁盘',
      // 搜索栏
      searchBar: {placeholder: '搜索名称或者 ECC ID', btn: '搜索'},
      // 地区过滤
      regionFilter: {header: '位置：'},
      // 列表
      list: {
        headerColumns: {
          name: '磁盘名称 / ID',
          instance: '挂载实例',
          period: '有效期限',
          size: '磁盘种类',
          diskTypes: {normal: '普通云盘', he: '高效云盘'},
          logic: {yes: '可以', no: '不可以'},
          zone: '可用区',
          type: {header: '磁盘属性', types: {system: '系统盘', data: '数据盘'}},
          detachable: '是否可卸载',
          status: {
            header: '磁盘状态',
            statuses: {
              deleted: '已删除',
              unknown: '未知',
              creating: '创建中',
              unmounted: '未挂载',
              mounting: '挂载中',
              inUse: '使用中',
              unmounting: '卸载中',
              paused: '已暂停',
              expired: '已过期'
            }
          },
          purchaseMethod: {
            header: '购买方式',
            methods: {
              systemDisk: '系统盘',
              packaged: '套餐数据盘',
              separately: '加购数据盘'
            }
          },
          action: {
            header: '操作',
            actions: {
              massAction: '批量操作',
              view: '查看',
              renew: '续费',
              createSnapshot: '创建快照',
              mount: '挂载',
              unmount: '卸载',
              viewSnapshot: '查看快照'
            }
          }
        }
      },
      regionLoadingTip: '正在获取区域数据，请稍候',
      // 创建快照弹框
      createSnapshotDialog: {
        header: '创建快照',
        disk: '磁盘 ID:',
        ip: '公网 IP:',
        category: '磁盘属性:',
        cateSys: '系统盘',
        cateData: '数据盘',
        snapshotName: '快照名称:',
        placeholder: '请输入快照名称',
        tip: '为了确保快照创建成功，正在创建快照时，请勿修改实例状态，比如关机、重启实例或重装等任何操作，否则会创建失败。请耐心等待。',
        btnCancel: '取消',
        btnDone: '确定'
      },
      // 续费弹框
      renewDialog: {
        header: '续费',
        selectedInstances: '已选择<span>#num#</span><span>台实例</span>',
        renewable: '可续费',
        duration: {
          header: '时长：',
          periods: {month: '月', months: '月', year: '年', years: '年'}
        },
        charges: '费用',
        buttons: {cancel: '取消', pay: '支付', pending: '处理中'}
      },
      // 卸载弹框
      unmountDialog: {
        header: '磁盘卸载',
        ask: '确定卸载磁盘',
        agreement: '解除挂载后，磁盘将不能正常提供服务。请做好准备，以避免任何影响。',
        buttons: {cancel: '取消', umount: '卸载'}
      },
      // 挂载弹框
      mountDialog: {
        header: '磁盘挂载',
        disk: '磁盘：',
        instance: '拟挂载的目标实例：',
        buttons: {cancel: '取消', mount: '挂载'}
      },
      // 磁盘详情页
      detail: {
        createdAt: '创建时间',
        attachingInfo: {
          header: '磁盘挂载信息',
          attachTo: '挂载的实例',
          status: {header: '状态：', unmounted: '未挂载', inUse: '使用中', paused: '已暂停', expired: '已过期'},
          mountPoint: '挂载点：',
          releaseWithIns: '随实例释放：',
          followInstance: {yes: '是', no: '否'},
          action: {header: '操作', mount: '挂载', unmount: '卸载', editDesc: '修改磁盘名称和描述'}
        },
        serviceInfo: {
          header: '业务信息',
          charges: '费用：',
          durationUnit: '月',
          creationTime: '创建时间：',
          expirationTime: '过期时间：',
          renew: '续费'
        },
        basicInfo: {
          header: '基本信息',
          diskName: '磁盘名称：',
          category: {header: '磁盘种类：', normal: '普通云盘', hp: '高效云盘'},
          status: {header: '状态：', unmounted: '未挂载', inUse: '使用中', paused: '已暂停', expired: '已过期'},
          size: '容量(GB)：',
          detachable: {header: '是否可卸载：', yes: '是', no: '否'},
          type: {header: '磁盘属性：', sys: '系统盘', data: '数据盘'},
          autoSnap: {header: '自动快照策略：', yes: '是', no: '否'},
          createdAt: '创建时间：',
          desc: '磁盘描述：'
        }
      },
      // 编辑磁盘描述弹框
      editDescDialog: {
        header: '编辑描述',
        name: {header: '磁盘名称：', tip: '长度限制为 6-30 个字符。以字母开头，可以包含数字、“.”、“_”或“-”。'},
        desc: {header: '磁盘描述：', tip: '最多 200 个字符，不能以 http:// 或 https:// 开头。'},
        buttons: {cancel: '取消', edit: '编辑'}
      }
    },
    // 快照
    snapshot: {
      name: '快照',
      list: {
        searchBar: {placeholder: '快照名称 / ID 或者 ECC ID 或者磁盘 ID', btn: '搜索'},
        headerColumns: {
          name: '快照名称 / ID',
          disk: '磁盘',
          creationTime: '创建时间',
          associatedServer: '关联服务器',
          status: {header: '状态'},
          action: {header: '操作', delete: '删除', rollback: '回滚', editTag: '修改名称'}
        }
      },
      // 删除弹框
      deleteDialog: {
        header: '删除快照',
        tip1: '确定删除 <span style="color:#37f;">#sn#</span> 吗？',
        tip2: '删除后将不能恢复，请谨慎操作。',
        buttons: {cancel: '取消', delete: '删除'}
      },
      // 回滚弹框
      rollbackDialog: {
        header: '回滚磁盘',
        notes: {
          one: '系统盘上的数据将被清除。请谨慎处理！',
          two: '只有当实例已经停止并且当前磁盘没有正在创建的快照时，磁盘才能回滚。',
          three: '为确保快照回滚成功，请不要在回滚过程中更改实例状态，如关闭、重启或重新安装实例。否则，回滚将失败。请耐心等待。',
        },
        options: {
          one: {
            one: '立即关闭并回滚',
            two: '自动关机（必须先关机才能立即回滚）',
            three: '确认立即关闭'
          },
          two: {
            one: '申请回滚',
            two: '回滚需要一定时间。申请回滚后，系统会向您发送电子邮件，提醒您回滚。然后系统将自动关机并进行回滚。'
          },
          agreement: '回滚后立即重启实例',
          buttons: {cancel: '取消', rollback: '回滚'}
        }
      },
      // 修改名称弹框
      editTagDialog: {
        header: '修改快照名称',
        id: '快照 ID:',
        oldName: '名称：',
        newName: '新名称：',
        placeholder: '',
        tip: '长度限制为 6-24 个字符 以字母开头，可以包含数字、“.” 和 ”_”',
        buttons: {cancel: '取消', save: '保存'}
      }
    },
    // 快照策略
    snapshotPolicy: {
      name: '快照策略',
      createBtn: '创建快照策略',
      // 创建快照策略弹框
      createDialog: {
        header: {create: '创建策略', edit: '修改策略'},
        name: {header: '策略名称：', placeholder: '请输入策略名称'},
        createdAt: '创建时间：',
        repeat: '重复：',
        days: {
          monday: '星期一',
          tuesday: '星期二',
          wednesday: '星期三',
          thursday: '星期四',
          friday: '星期五',
          saturday: '星期六',
          sunday: '星期日'
        },
        retentionTime: {
          header: '保留时间：',
          options: {
            one: {header: '自定义时长', unit: '天 (1 到 30)'},
            two: {header: '持续保留，直到快照数量达到最大限制'}
          },
          notes: {
            one: '快照服务允许您为云盘创建多达 64 个自动快照。当达到云盘自动快照的最大数量时，系统会在创建新快照时自动删除最早的自动快照。',
            two: '如果磁盘数据量大，一次打快照时长超过两个自动快照时间点间隔，则下一个时间点不打快照自动跳过。例如:用户设置9:00、10:00、11:00为自动快照时间点，9:00打快照的时候时 长为70分钟，也就是10:10才打完，那10:00预设时间点将不打快照，下个快照时间点为 11:00。',
            three: '当前快照策略执行时间默认为东八区(UTC+8)时间。',
            four: '手动快照可持续保留，直至账户欠费停止服务15天后，会被删除。',
            five: '为了保证快照创建成功，正在创建快照时，您不能修改云服务器状态，比如停止或重启。请耐心等待。',
            expandBtn: '更多'
          }
        },
        buttons: {cancel: '取消', confirm: '确定'}
      },
      // 列表
      list: {
        searchBar: {placeholder: '搜索策略名称', search: '搜索'},
        headerColumns: {
          name: '策略名称',
          detail: '详情',
          detailRows: {
            executeTime: '执行时间：',
            executeFrequency: '执行频率：',
            keepSnapshot: '保留快照：'
          },
          relatedDisks: '关联磁盘数',
          createTime: '创建时间',
          action: {
            header: '操作',
            modify: '修改',
            apply: '设置自动快照策略',
            delete: '删除'
          }
        }
      },
      // 删除弹框
      deleteDialog: {
        header: '删除自动快照策略',
        ask: '您确定要删除自动快照策略',
        tip: '删除后无法恢复。请谨慎操作。',
        buttons: {cancel: '取消', confirm: '确认'}
      },
      // 应用策略弹框
      applyDialog: {
        header: '设置自动快照策略',
        tip: '启用自动快照策略后，系统将按照您设置的快照创建时间点、重复日期、保留时间等策略来管理您的快照。',
        tabs: {
          without: '未设置策略磁盘',
          with: '已设置策略磁盘',
        },
        searchPlaceholder: '搜索磁盘 ID/名称或者实例 ID/名称',
        diskColumns: {
          name: '磁盘 ID/名称',
          instance: '实例 ID/名称',
          disk: '磁盘',
          action: {header: '操作', execute: '应用快照策略', cancel: '撤销快照策略'}
        },
        diskCategories: {normal: '普通云盘', hp: '高效云盘'},
        diskTypes: {sys: '系统盘', data: '数据盘'},
        buttons: {close: '关闭'}
      }
    },
    // ip
    ip: {
      name: 'IP带宽',
      // 购买弹框
      purchaseBtn: '购买IP',
      purchaseDialog: {
        header: '购买独立 IP',
        instance: {header: '绑定实例：', placeholder: '请选择要绑定的实例'},
        quantity: '数量：',
        bandwidth: '带宽(M)：',
        duration: {
          header: '时长：',
          units: {month: '月', months: '月', year: '年', years: '年'}
        },
        charges: '费用：',
        buttons: {cancel: '取消', pay: '支付', pending: '处理中'}
      },
      // 列表页
      list: {
        searchBar: {placeholder: '搜索 IP', search: '搜索'},
        regionFilter: {header: '位置：', placeholder: '选择地域以筛选'},
        headerColumns: {
          status: {
            header: '状态',
            statuses: {
              unbound: '未绑定',
              bound: '已绑定',
              expired: '已过期'
            }
          },
          zone: '机房',
          boundServer: '已绑定实例',
          bandwidth: '带宽',
          purchasingMethod: {
            header: '购买方式',
            methods: {package: '随实例附送', separately: '单独购买'}
          },
          price: '价格($/月)',
          validity: '有效期限',
          action: {
            header: '操作',
            renew: '续费',
            bind: '绑定',
            unbind: '解绑'
          }
        }
      },
      // 续费弹框
      renewDialog: {
        header: '续费',
        duration: {
          header: '时长：',
          units: {month: '月', months: '月', year: '年', years: '年'}
        },
        charges: '费用',
        buttons: {cancel: '取消', pay: '支付', pending: '处理中'}
      },
      // 解绑弹框
      unbindDialog: {
        header: '解绑',
        ask: '你确定要对 <span style="color:#37f;">#ip#</span> 执行解绑操作？',
        instance: '已绑定实例',
        tip: '解绑IP，服务器会重启，请先确认数据保存，解绑后可能会影响您的业务，请提前做好准备。',
        buttons: {cancel: '取消', unbind: '解绑'}
      },
      // 绑定弹框
      bindDialog: {
        header: '绑定',
        ip: 'IP 地址',
        instancePickerTip: '请选择 IP 需要绑定的实例：',
        searchPlaceholder: '搜索',
        units: {cpu: '核', memory: '内存'},
        statuses: {
          creating: '创建中',
          initializing: '初始化中',
          starting: '启动中',
          running: '运行中',
          stopping: '正在停止',
          stopped: '已停止',
          expiringSoon: '即将过期',
          unknown: '未知状态'
        },
        buttons: {cancel: '取消', bind: '绑定'}
      }
    },
    // 安全组
    securityGroup: {
      name: '安全组',
      createBtn: '创建安全组',
      // 创建/编辑弹框
      createDialog: {
        header: '创建安全组',
        editHeader: '编辑安全组',
        name: {header: '名称', placeholder: '请输入安全组名称'},
        tag: {header: '标签', placeholder: '请输入标签名'},
        desc: '描述',
        buttons: {cancel: '取消', confirm: '确认'}
      },
      // 删除弹框
      deleteDialog: {
        header: '删除安全组',
        ask: '您确定要删除选定的安全组吗',
        instance: {
          header: '已选择的安全组',
          selected: '已选择 <span style="color:#37f;">#num#</span>&nbsp;<span style="color:#37f;">个安全组</span>'
        },
        buttons: {cancel: '取消', delete: '删除'}
      },
      // 列表
      list: {
        searchBar: {placeholder: '搜索 ID / 名称', search: '搜索'},
        headerColumns: {
          id: 'ID',
          name: '名称',
          tag: '标签',
          relatedInstances: '关联实例数',
          createTime: '创建时间',
          action: {
            header: '操作',
            configure: '配置',
            edit: '编辑',
            delete: '删除',
            deleteTip: '请在删除安全组之前删除相关实例。',
            massAction: '批量操作：'
          }
        }
      },
      // 配置页
      configure: {
        tabs: {inboundRules: '入站规则', manageInstances: '管理实例'},
        headButtons: {addRule: '添加规则', addInstance: '新增关联'},
        ruleHeaderColumns: {
          id: 'ID / 安全组名称',
          authorizationObject: '来源',
          protocolType: '协议类型',
          portRange: '端口范围',
          action: '策略',
          desc: '描述',
          priority: '优先级',
          actions: {header: '操作', modify: '修改', delete: '删除'}
        },
        insHeaderColumns: {
          id: '实例 ID',
          name: '名称',
          ip: 'IP 地址',
          zone: '机房',
          actions: {header: '操作', remove: '移除'}
        },
        noInsTip: '请在实例列表中将实例添加到安全组',
        massAction: '批量操作：'
      },
      // 删除规则弹框
      deleteRuleDialog: {
        header: '删除安全组规则',
        ask: '您确定要删除选定的规则吗',
        selectedRules: '已选择的规则',
        selectedCount: '已选择 <span style="color:#37f;">#num#</span> <span style="color:#37f;">条规则</span>',
        buttons: {cancel: '取消', delete: '删除'}
      },
      // 修改规则弹框
      editRuleDialog: {
        header: '修改规则',
        protocolType: {
          header: '协议类型',
          placeholder: '请选择',
          options: {
            all: '所有',
            customTcp: '自定义 TCP',
            customUdp: '自定义 UDP'
          }
        },
        authObj: {
          header: '授权对象',
          tip: '所有 IP (0.0.0.0), 单个 IP (10. x.x.y), IP 段 (x.y.z.0 / 24), 多个 IP (10. x.y.z, 11. x.y.z, 12. x.y.z)',
          placeholder: '请输入规则名称'
        },
        portRange: {
          header: '端口范围',
          tip: '单个端口 (22), 端口范围 (10 / 20), 所有端口 (- 1 / - 1)'
        },
        action: {
          header: '动作',
          options: {
            allowed: '允许',
            notAllowed: '拒绝'
          }
        },
        desc: '描述',
        priority: {
          header: '优先级',
          tip: '1 到 99',
          placeholder: '请输入优先级值'
        },
        buttons: {cancel: '取消', confirm: '确定'}
      },
      // 添加规则弹框
      addRuleDialog: {
        header: '添加入站规则',
        tips: {
          one: '首次加入安全组，默认拒绝所有端口，请按需要添加允许策略规则。',
          two: '来源格式：所有IP（0.0.0.0） 单个IP（10.x.x.y） IP段（x.y.z.0/24） 多个IP（10.x.y.z,11.x.y.z,12.x.y.z）',
          three: '端口格式：单个端口（22） 端口范围（10/20） 全部端口（-1/-1）',
          four: '优先级：范围1-99 数字越小优先级越高'
        },
        headerColumns: {
          protocolType: '协议类型',
          authObj: {header: '授权对象', placeholder: '例如：0.0.0.0/0'},
          portRange: {header: '端口范围', placeholder: '请填写'},
          action: {header: '动作', options: {allow: '允许', reject: '拒绝'}},
          remark: {header: '备注', placeholder: '请填写'},
          priority: {header: '优先级', placeholder: '请填写'},
          actions: {header: '操作', delete: '删除'}
        },
        appendBtn: '添加',
        buttons: {cancel: '取消', confirm: '确定'}
      },
      // 绑定实例弹框
      bindInstanceDialog: {
        header: '添加实例到安全组',
        selectedGroup: '已选择的安全组：',
        placeholder: '输入名称、ID 或者 IP 进行搜索',
        headerColumns: {
          instance: '实例 ID/名称',
          intranet: '所属内网',
          ip: 'IP 地址',
          public: ' (公网)'
        },
        buttons: {cancel: '取消', confirm: '确定'}
      }
    },
    // 内网
    intranet: {
      name: '内网',
      // 创建弹框
      createDialog: {
        header: {create: '创建内网', edit: '编辑'},
        name: {header: '名称：', placeholder: '请输入内网名称'},
        desc: '描述：',
        networkSegment: '网段：',
        buttons: {cancel: '取消', confirm: '确定'}
      },
      // 列表
      list: {
        searchBar: {placeholder: '搜索 IP / 名称', search: '搜索'},
        headerColumns: {
          networkSegment: '网段',
          name: '名称',
          desc: '描述',
          createTime: '创建时间',
          actions: {header: '操作', view: '查看', edit: '编辑'}
        },
        tips: {
          one: '<span style="font-weight:bold;">安全隔离：</span><br>基于亿速云构建出隔离的网络环境，不同云服务器保证二层逻辑隔离',
          two: '<span style="font-weight:bold;">灵活：</span><br>软件定义网络，按需配置网络，可自定义IP 地址范围与路由表等',
          three: '<span style="font-weight:bold;">完全免费：</span><br>基于亿速云免费实现完全隔离的云上专有网络',
          four: '<span style="font-weight:bold;">适用范围：</span><br>相同区域线路的云服务器可通过内网互相访问，不同区区域的暂不可通过内网互相访问'
        }
      },
      // 详情页
      detail: {
        title: '内网：',
        subTitle: '内网：',
        headerColumns: {
          zone: '机房',
          name: '名称',
          configuration: '配置'
        },
        units: {core: '核'},
        notes: {
          one: '<span style="font-weight:bold;">安全隔离：</span><br>基于亿速云构建出隔离的网络环境，不同云服务器保证二层逻辑隔离',
          two: '<span style="font-weight:bold;">灵活：</span><br>软件定义网络，按需配置网络，可自定义IP 地址范围与路由表等',
          three: '<span style="font-weight:bold;">完全免费：</span><br>基于亿速云免费实现完全隔离的云上专有网络',
          four: '<span style="font-weight:bold;">适用范围：</span><br>相同区域线路的云服务器可通过内网互相访问，不同区区域的暂不可通过内网互相访问'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/ecc.js